<template>
  <div class="crud-peleador">
    <!-- ── HEADER ── -->
    <div class="page-header">
      <div>
        <h1 class="page-title-wrap">Peleadores</h1>
        <p class="page-sub">Evento activo · {{ peleadoresFiltrados.length }} registros</p>
      </div>
      <div class="header-actions">
        <div class="busqueda-wrap">
          <i class="bi bi-search busqueda-icon"></i>
          <input
            v-model="busqueda"
            class="input-busqueda"
            placeholder="Buscar por nombre, email o equipo..."
            @input="pagina = 1"
          />
          <button
            v-if="busqueda"
            class="busqueda-clear"
            @click="
              busqueda = '';
              pagina = 1;
            "
          >
            <i class="bi bi-x"></i>
          </button>
        </div>
        <button class="btn-secondary" @click="abrirFiltros = !abrirFiltros">
          <i class="bi bi-funnel"></i> Filtrar
        </button>
        <button
          class="btn-secondary"
          :disabled="generandoGafetesPdf"
          @click="descargarGafetesPeleadores"
        >
          <span v-if="generandoGafetesPdf"
            ><span class="spinner-border spinner-border-sm"></span
          ></span>
          <span v-else><i class="bi bi-qr-code-scan"></i> Generar gafetes (PDF)</span>
        </button>
        <button class="btn-primary" @click="abrirAltaMasiva">
          <i class="bi bi-person-plus-fill"></i> Agregar peleadores
        </button>
      </div>
    </div>

    <!-- ── FILTROS ── -->
    <div v-if="abrirFiltros" class="filtros-bar">
      <select v-model="filtroEstatus" class="filtro-select" @change="cargar">
        <option value="">Todos los estatus</option>
        <option value="confirmado">Confirmado</option>
        <option value="pendiente">Pendiente</option>
        <option value="rechazado">Rechazado</option>
      </select>
      <select v-model="filtroRol" class="filtro-select" @change="cargar">
        <option value="">Todos los roles</option>
        <option v-for="r in roles" :key="r.value" :value="r.value">{{ r.label }}</option>
      </select>
      <button class="btn-ghost" @click="limpiarFiltros">
        <i class="bi bi-x"></i> Limpiar
      </button>
    </div>

    <!-- ── TABLA ── -->
    <div class="tabla-wrapper">
      <div v-if="cargando" class="estado-centro">
        <span class="spinner-border spinner-border-sm text-warning me-2"></span>
        Cargando peleadores...
      </div>

      <div v-else-if="!peleadoresFiltrados.length" class="estado-centro vacio">
        <i class="bi bi-person-x" style="font-size: 2rem; opacity: 0.3"></i>
        <p>Sin peleadores registrados</p>
      </div>

      <table v-else class="tabla">
        <thead>
          <tr>
            <th @click="toggleSort('nombre')" class="th-sortable">
              Peleador
              <span class="sort-icon"><i :class="sortIconClass('nombre')"></i></span>
            </th>
            <th @click="toggleSort('email')" class="th-sortable">
              Email <span class="sort-icon"><i :class="sortIconClass('email')"></i></span>
            </th>
            <th @click="toggleSort('peso_kg')" class="th-sortable">
              Peso
              <span class="sort-icon"><i :class="sortIconClass('peso_kg')"></i></span>
            </th>
            <th @click="toggleSort('cinta')" class="th-sortable">
              Cinta <span class="sort-icon"><i :class="sortIconClass('cinta')"></i></span>
            </th>
            <th @click="toggleSort('rol')" class="th-sortable">
              Rol <span class="sort-icon"><i :class="sortIconClass('rol')"></i></span>
            </th>
            <th @click="toggleSort('estatus_inscripcion')" class="th-sortable">
              Estatus
              <span class="sort-icon"
                ><i :class="sortIconClass('estatus_inscripcion')"></i
              ></span>
            </th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in paginaActual" :key="p.id" class="tabla-fila">
            <td>
              <div class="peleador-cell">
                <img
                  v-if="p.foto"
                  :src="p.foto"
                  class="avatar"
                  :alt="`${p.nombre} ${p.apellido}`"
                />
                <div v-else class="avatar-placeholder">
                  {{ p.nombre?.charAt(0) }}{{ p.apellido?.charAt(0) }}
                </div>
                <div>
                  <p class="nombre">{{ p.nombre }} {{ p.apellido }}</p>
                  <p class="equipo">{{ p.equipo }}</p>
                </div>
              </div>
            </td>
            <td>{{ p.email }}</td>
            <td>{{ p.peso_kg }} kg</td>
            <td>
              <span :class="['badge-cinta', p.cinta]">{{
                p.cinta_display || p.cinta
              }}</span>
            </td>
            <td>
              <span class="badge-rol">{{ p.rol_display || p.rol }}</span>
            </td>
            <td>
              <span :class="['badge-estatus', p.estatus_inscripcion]">
                {{ labelEstatus(p.estatus_inscripcion) }}
              </span>
            </td>
            <td>
              <button class="btn-icon" title="Editar" @click="abrirEditar(p)">
                <i class="bi bi-pencil-fill"></i>
              </button>
              <button
                class="btn-icon"
                title="Pase de identificación"
                :disabled="descargandoGafeteId === p.id"
                @click="descargarGafetePeleador(p)"
              >
                <span v-if="descargandoGafeteId === p.id" class="spinner-border spinner-border-sm"></span>
                <i v-else class="bi bi-qr-code"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- ── PAGINACIÓN ── -->
      <div v-if="totalPaginas > 1" class="paginacion">
        <button class="pag-btn" :disabled="pagina === 1" @click="pagina--">
          <i class="bi bi-chevron-left"></i>
        </button>
        <template v-for="n in paginasVisibles" :key="n">
          <span v-if="n === '...'" class="pag-ellipsis">…</span>
          <button
            v-else
            :class="['pag-btn', { 'pag-activa': n === pagina }]"
            @click="pagina = n"
          >
            {{ n }}
          </button>
        </template>
        <button class="pag-btn" :disabled="pagina === totalPaginas" @click="pagina++">
          <i class="bi bi-chevron-right"></i>
        </button>
        <span class="pag-info">
          {{ (pagina - 1) * porPagina + 1 }}–{{
            Math.min(pagina * porPagina, peleadoresFiltrados.length)
          }}
          de {{ peleadoresFiltrados.length }}
        </span>
      </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════
         MODAL — ALTA MASIVA
    ════════════════════════════════════════════════════════════════════ -->
    <div v-if="modalAltaMasiva" class="modal-overlay" @click.self="cerrarAltaMasiva">
      <div class="modal-panel modal-grande">
        <div class="modal-header">
          <div>
            <h2 class="modal-titulo">Agregar peleadores</h2>
            <p class="modal-sub">
              Completa los datos de cada peleador. Los campos marcados con * son
              obligatorios.
            </p>
          </div>
          <button class="btn-icon" @click="cerrarAltaMasiva">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="tabla-alta-wrapper">
          <table class="tabla-alta">
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre *</th>
                <th>Apellido *</th>
                <th>Email *</th>
                <th>Teléfono *</th>
                <th>Peso (kg) *</th>
                <th>Cinta *</th>
                <th>Rol</th>
                <th>Notificar</th>
                <th>+ Datos</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(fila, idx) in filas"
                :key="idx"
                :class="['fila-editable', resultadoFila(idx)]"
              >
                <td class="td-num">{{ idx + 1 }}</td>
                <td>
                  <input v-model="fila.nombre" class="input-tabla" placeholder="Nombre" />
                </td>
                <td>
                  <input
                    v-model="fila.apellido"
                    class="input-tabla"
                    placeholder="Apellido"
                  />
                </td>
                <td>
                  <input
                    v-model="fila.email"
                    class="input-tabla"
                    placeholder="email@..."
                    type="email"
                  />
                </td>
                <td>
                  <input
                    v-model="fila.telefono"
                    class="input-tabla"
                    placeholder="+52..."
                  />
                </td>
                <td>
                  <input
                    v-model="fila.peso_kg"
                    class="input-tabla input-num"
                    placeholder="70.0"
                    type="number"
                    step="0.1"
                  />
                </td>
                <td>
                  <select v-model="fila.cinta" class="input-tabla">
                    <option value="">-- Cinta --</option>
                    <option v-for="c in cintas" :key="c.value" :value="c.value">
                      {{ c.label }}
                    </option>
                  </select>
                </td>
                <td>
                  <select v-model="fila.rol" class="input-tabla">
                    <option v-for="r in roles" :key="r.value" :value="r.value">
                      {{ r.label }}
                    </option>
                  </select>
                </td>
                <td class="td-center">
                  <input type="checkbox" v-model="fila.notificar" class="check-notif" />
                </td>
                <td class="td-center">
                  <button
                    class="btn-icon-sm"
                    title="Datos adicionales"
                    @click="abrirDatosExtra(idx)"
                  >
                    <i class="bi bi-three-dots"></i>
                  </button>
                </td>
                <td class="td-center">
                  <i
                    v-if="resultados[idx]?.ok"
                    class="bi bi-check-circle-fill text-success"
                  ></i>
                  <i
                    v-else-if="resultados[idx]"
                    class="bi bi-x-circle-fill text-danger"
                    :title="errorMsgFila(idx)"
                  ></i>
                  <button
                    v-else
                    class="btn-icon-sm btn-danger-ghost"
                    @click="eliminarFila(idx)"
                  >
                    <i class="bi bi-trash3"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="modal-footer">
          <button class="btn-ghost" @click="agregarFila">
            <i class="bi bi-plus-lg"></i> Agregar fila
          </button>
          <div class="footer-right">
            <span
              v-if="resumenResultado"
              :class="['resumen-badge', resumenResultado.clase]"
            >
              {{ resumenResultado.texto }}
            </span>
            <button class="btn-secondary" @click="cerrarAltaMasiva">Cancelar</button>
            <button
              class="btn-primary"
              :disabled="enviando || !filasValidas.length"
              @click="enviarAltaMasiva"
            >
              <span v-if="enviando">
                <span class="spinner-border spinner-border-sm"></span> Procesando...
              </span>
              <span v-else>
                <i class="bi bi-cloud-upload-fill"></i>
                Dar de alta {{ filasValidas.length }} peleador{{
                  filasValidas.length !== 1 ? "es" : ""
                }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════
         DRAWER — DATOS EXTRA (dentro del modal de alta masiva)
    ════════════════════════════════════════════════════════════════════ -->
    <div
      v-if="drawerExtraIdx !== null"
      class="modal-overlay"
      @click.self="drawerExtraIdx = null"
    >
      <div class="modal-panel modal-chico">
        <div class="modal-header">
          <h2 class="modal-titulo">Datos adicionales — fila {{ drawerExtraIdx + 1 }}</h2>
          <button class="btn-icon" @click="drawerExtraIdx = null">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="form-grid" v-if="filas[drawerExtraIdx]">
          <!-- ── Foto ── -->
          <div class="form-group col-span-2">
            <label><i class="bi bi-camera-fill"></i> Foto del peleador</label>
            <div
              class="foto-upload-zone"
              :class="{ 'foto-drag-over': drawerFotoDragOver }"
              @click="drawerInputFoto?.click()"
              @dragover.prevent="drawerFotoDragOver = true"
              @dragleave.prevent="drawerFotoDragOver = false"
              @drop.prevent="
                (e) => {
                  drawerFotoDragOver = false;
                  onDrawerFotoDrop(e);
                }
              "
            >
              <img
                v-if="filas[drawerExtraIdx]._fotoPreview"
                :src="filas[drawerExtraIdx]._fotoPreview"
                class="foto-preview"
                alt="Foto"
              />
              <div v-else class="foto-placeholder">
                <i class="bi bi-person-bounding-box"></i>
                <span>Arrastra una imagen o haz clic para seleccionar</span>
                <span class="foto-hint">JPG, PNG o WEBP · Opcional</span>
              </div>
              <div v-if="filas[drawerExtraIdx]._fotoPreview" class="foto-hover-overlay">
                <i class="bi bi-camera-fill"></i>
                <span>Cambiar foto</span>
              </div>
            </div>
            <div v-if="filas[drawerExtraIdx]._foto" class="foto-nueva-badge">
              <i class="bi bi-check-circle-fill text-success"></i>
              {{ filas[drawerExtraIdx]._foto.name }}
              <button
                class="btn-quitar-foto"
                @click.stop="quitarFotoDrawer"
                title="Quitar"
              >
                <i class="bi bi-x"></i>
              </button>
            </div>
            <input
              ref="drawerInputFoto"
              type="file"
              accept="image/*"
              style="display: none"
              @change="onDrawerFotoSeleccionada"
            />
          </div>

          <div class="form-group">
            <label>Fecha de nacimiento *</label>
            <input
              v-model="filas[drawerExtraIdx].fecha_nacimiento"
              type="date"
              class="input-form"
            />
          </div>
          <div class="form-group">
            <label>Género *</label>
            <select v-model="filas[drawerExtraIdx].genero" class="input-form">
              <option value="H">Hombre</option>
              <option value="M">Mujer</option>
            </select>
          </div>
          <div class="form-group">
            <label>Nacionalidad *</label>
            <select v-model="filas[drawerExtraIdx].nacionalidad" class="input-form">
              <option v-for="n in nacionalidades" :key="n.value" :value="n.value">
                {{ n.label }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Equipo / Academia *</label>
            <input
              v-model="filas[drawerExtraIdx].equipo"
              type="text"
              class="input-form"
              placeholder="Nombre del equipo"
            />
          </div>
          <div class="form-group col-span-2">
            <label>Dirección / Ciudad</label>
            <input
              v-model="filas[drawerExtraIdx].direccion"
              type="text"
              class="input-form"
              placeholder="Ciudad, Estado"
            />
          </div>
          <div class="form-group col-span-2">
            <label>Trayectoria</label>
            <textarea
              v-model="filas[drawerExtraIdx].trayectoria"
              class="input-form"
              rows="3"
              placeholder="Resumen de carrera..."
            ></textarea>
          </div>

          <div class="form-section-label col-span-2">
            <i class="bi bi-share-fill"></i> Redes sociales
          </div>
          <div class="form-group">
            <label><i class="bi bi-instagram"></i> Instagram</label>
            <input
              v-model="filas[drawerExtraIdx].redes_sociales.instagram"
              type="url"
              class="input-form"
              placeholder="https://instagram.com/..."
            />
          </div>
          <div class="form-group">
            <label><i class="bi bi-facebook"></i> Facebook</label>
            <input
              v-model="filas[drawerExtraIdx].redes_sociales.facebook"
              type="url"
              class="input-form"
              placeholder="https://facebook.com/..."
            />
          </div>
          <div class="form-group">
            <label><i class="bi bi-youtube"></i> YouTube</label>
            <input
              v-model="filas[drawerExtraIdx].redes_sociales.youtube"
              type="url"
              class="input-form"
              placeholder="https://youtube.com/..."
            />
          </div>
          <div class="form-group">
            <label><i class="bi bi-twitter-x"></i> Twitter / X</label>
            <input
              v-model="filas[drawerExtraIdx].redes_sociales.twitter"
              type="url"
              class="input-form"
              placeholder="https://x.com/..."
            />
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn-primary" @click="drawerExtraIdx = null">
            <i class="bi bi-check2"></i> Listo
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════
         MODAL — EDITAR PELEADOR (con tabs internos)
    ════════════════════════════════════════════════════════════════════ -->
    <div v-if="drawerEditar" class="modal-overlay" @click.self="cerrarEditar">
      <div class="modal-panel modal-mediano">
        <div class="modal-header">
          <div class="editar-header-info">
            <img
              v-if="peleadorEditar?.foto"
              :src="peleadorEditar.foto"
              class="avatar avatar-modal"
            />
            <div v-else class="avatar-placeholder avatar-modal">
              {{ peleadorEditar?.nombre?.charAt(0)
              }}{{ peleadorEditar?.apellido?.charAt(0) }}
            </div>
            <div>
              <h2 class="modal-titulo">
                {{ peleadorEditar?.nombre }} {{ peleadorEditar?.apellido }}
              </h2>
              <p class="modal-sub">{{ peleadorEditar?.equipo }}</p>
            </div>
          </div>
          <button class="btn-icon" @click="cerrarEditar">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <!-- Tabs -->
        <div class="modal-tabs">
          <button
            :class="['tab-btn', { 'tab-activo': tabEditar === 'general' }]"
            @click="tabEditar = 'general'"
          >
            <i class="bi bi-person-fill"></i> General
          </button>
          <button
            :class="['tab-btn', { 'tab-activo': tabEditar === 'extra' }]"
            @click="tabEditar = 'extra'"
          >
            <i class="bi bi-info-circle-fill"></i> Datos adicionales
          </button>
        </div>

        <div class="form-grid" v-if="peleadorEditar">
          <!-- ── Tab General ── -->
          <template v-if="tabEditar === 'general'">
            <!-- ── Foto de perfil ── -->
            <div class="form-group col-span-2">
              <label><i class="bi bi-camera-fill"></i> Foto del peleador</label>
              <div
                class="foto-upload-zone"
                :class="{ 'foto-drag-over': fotoDragOver }"
                @click="inputFoto?.click()"
                @dragover.prevent="fotoDragOver = true"
                @dragleave.prevent="fotoDragOver = false"
                @drop.prevent="
                  (e) => {
                    fotoDragOver = false;
                    onFotoDrop(e);
                  }
                "
              >
                <!-- Preview: foto nueva o existente -->
                <img
                  v-if="fotoPreview || peleadorEditar.foto"
                  :src="fotoPreview || peleadorEditar.foto"
                  class="foto-preview"
                  alt="Foto del peleador"
                />
                <!-- Placeholder cuando no hay foto -->
                <div v-else class="foto-placeholder">
                  <i class="bi bi-person-bounding-box"></i>
                  <span>Arrastra una imagen o haz clic para seleccionar</span>
                  <span class="foto-hint">JPG, PNG o WEBP · Max 5 MB</span>
                </div>

                <!-- Overlay al hacer hover sobre una foto existente -->
                <div v-if="fotoPreview || peleadorEditar.foto" class="foto-hover-overlay">
                  <i class="bi bi-camera-fill"></i>
                  <span>Cambiar foto</span>
                </div>
              </div>

              <!-- Indicador de foto nueva seleccionada + botón quitar -->
              <div v-if="fotoNueva" class="foto-nueva-badge">
                <i class="bi bi-check-circle-fill text-success"></i>
                {{ fotoNueva.name }}
                <button
                  class="btn-quitar-foto"
                  @click.stop="quitarFotoNueva"
                  title="Quitar foto"
                >
                  <i class="bi bi-x"></i>
                </button>
              </div>

              <!-- Input oculto -->
              <input
                ref="inputFoto"
                type="file"
                accept="image/*"
                style="display: none"
                @change="onFotoSeleccionada"
              />
            </div>
            <div class="form-group">
              <label>Nombre</label>
              <input v-model="peleadorEditar.nombre" class="input-form" />
            </div>
            <div class="form-group">
              <label>Apellido</label>
              <input v-model="peleadorEditar.apellido" class="input-form" />
            </div>
            <div class="form-group">
              <label>Email</label>
              <input v-model="peleadorEditar.email" type="email" class="input-form" />
            </div>
            <div class="form-group">
              <label>Teléfono</label>
              <input v-model="peleadorEditar.telefono" class="input-form" />
            </div>
            <div class="form-group">
              <label>Fecha de nacimiento</label>
              <input
                v-model="peleadorEditar.fecha_nacimiento"
                type="date"
                class="input-form"
              />
            </div>
            <div class="form-group">
              <label>Género</label>
              <select v-model="peleadorEditar.genero" class="input-form">
                <option value="H">Hombre</option>
                <option value="M">Mujer</option>
              </select>
            </div>
            <div class="form-group">
              <label>Peso (kg)</label>
              <input
                v-model="peleadorEditar.peso_kg"
                type="number"
                step="0.1"
                class="input-form"
              />
            </div>
            <div class="form-group">
              <label>Nacionalidad</label>
              <select v-model="peleadorEditar.nacionalidad" class="input-form">
                <option v-for="n in nacionalidades" :key="n.value" :value="n.value">
                  {{ n.label }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Cinta</label>
              <select v-model="peleadorEditar.cinta" class="input-form">
                <option v-for="c in cintas" :key="c.value" :value="c.value">
                  {{ c.label }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Rol</label>
              <select v-model="peleadorEditar.rol" class="input-form">
                <option v-for="r in roles" :key="r.value" :value="r.value">
                  {{ r.label }}
                </option>
              </select>
            </div>
            <div class="form-group col-span-2">
              <label>Equipo / Academia</label>
              <input v-model="peleadorEditar.equipo" class="input-form" />
            </div>
          </template>

          <!-- ── Tab Datos adicionales ── -->
          <template v-if="tabEditar === 'extra'">
            <div class="form-group col-span-2">
              <label>Trayectoria</label>
              <textarea
                v-model="peleadorEditar.trayectoria"
                class="input-form"
                rows="4"
              ></textarea>
            </div>

            <div class="form-section-label col-span-2">
              <i class="bi bi-share-fill"></i> Redes sociales
            </div>
            <div class="form-group">
              <label><i class="bi bi-instagram"></i> Instagram</label>
              <input
                :value="peleadorEditar.redes_sociales?.instagram || ''"
                @input="setRed('instagram', $event.target.value)"
                type="url"
                class="input-form"
                placeholder="https://instagram.com/..."
              />
            </div>
            <div class="form-group">
              <label><i class="bi bi-facebook"></i> Facebook</label>
              <input
                :value="peleadorEditar.redes_sociales?.facebook || ''"
                @input="setRed('facebook', $event.target.value)"
                type="url"
                class="input-form"
                placeholder="https://facebook.com/..."
              />
            </div>
            <div class="form-group">
              <label><i class="bi bi-youtube"></i> YouTube</label>
              <input
                :value="peleadorEditar.redes_sociales?.youtube || ''"
                @input="setRed('youtube', $event.target.value)"
                type="url"
                class="input-form"
                placeholder="https://youtube.com/..."
              />
            </div>
            <div class="form-group">
              <label><i class="bi bi-twitter-x"></i> Twitter / X</label>
              <input
                :value="peleadorEditar.redes_sociales?.twitter || ''"
                @input="setRed('twitter', $event.target.value)"
                type="url"
                class="input-form"
                placeholder="https://x.com/..."
              />
            </div>
          </template>
        </div>

        <div class="modal-footer">
          <button class="btn-secondary" @click="cerrarEditar">Cancelar</button>
          <button class="btn-primary" :disabled="guardando" @click="guardarEdicion">
            <span v-if="guardando"
              ><span class="spinner-border spinner-border-sm"></span
            ></span>
            <span v-else><i class="bi bi-floppy-fill"></i> Guardar</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import Swal from "sweetalert2";
import {
  getPeleadoresDashboard,
  altaMasivaPeleadores,
  editarPeleador,
  getGafetePeleadorPdf,
  getGafetesPeleadoresPdf,
} from "@/utils/api_dashboard";

// ── Catálogos ────────────────────────────────────────────────────────────────
const cintas = [
  { value: "blanca", label: "Blanca" },
  { value: "blanca_amarilla", label: "Blanca-Amarilla" },
  { value: "amarilla", label: "Amarilla" },
  { value: "naranja", label: "Naranja" },
  { value: "verde", label: "Verde" },
  { value: "azul", label: "Azul" },
  { value: "morada", label: "Morada" },
  { value: "cafe", label: "Café" },
  { value: "negra", label: "Negra" },
];

// Valores coinciden exactamente con los que devuelve el backend (campo "rol")
const roles = [
  { value: "Competidor", label: "Competidor" },
  { value: "Estelar", label: "Estelar" },
  { value: "Estelar y Competidor", label: "Estelar y Competidor" },
  { value: "Invitado", label: "Invitado" },
];

const nacionalidades = [
  // América del Norte
  { value: "mx", label: "México" },
  { value: "us", label: "Estados Unidos" },
  { value: "ca", label: "Canadá" },

  // América Central y Caribe
  { value: "gt", label: "Guatemala" },
  { value: "bz", label: "Belice" },
  { value: "hn", label: "Honduras" },
  { value: "sv", label: "El Salvador" },
  { value: "ni", label: "Nicaragua" },
  { value: "cr", label: "Costa Rica" },
  { value: "pa", label: "Panamá" },
  { value: "cu", label: "Cuba" },
  { value: "do", label: "República Dominicana" },
  { value: "ht", label: "Haití" },
  { value: "pr", label: "Puerto Rico" },

  // América del Sur
  { value: "co", label: "Colombia" },
  { value: "ve", label: "Venezuela" },
  { value: "ec", label: "Ecuador" },
  { value: "pe", label: "Perú" },
  { value: "br", label: "Brasil" },
  { value: "bo", label: "Bolivia" },
  { value: "py", label: "Paraguay" },
  { value: "uy", label: "Uruguay" },
  { value: "ar", label: "Argentina" },
  { value: "cl", label: "Chile" },

  // Europa
  { value: "es", label: "España" },
  { value: "pt", label: "Portugal" },
  { value: "fr", label: "Francia" },
  { value: "de", label: "Alemania" },
  { value: "it", label: "Italia" },
  { value: "gb", label: "Reino Unido" },
  { value: "nl", label: "Países Bajos" },
  { value: "be", label: "Bélgica" },
  { value: "ch", label: "Suiza" },
  { value: "at", label: "Austria" },
  { value: "se", label: "Suecia" },
  { value: "no", label: "Noruega" },
  { value: "dk", label: "Dinamarca" },
  { value: "pl", label: "Polonia" },
  { value: "ru", label: "Rusia" },

  // Asia
  { value: "jp", label: "Japón" },
  { value: "cn", label: "China" },
  { value: "kr", label: "Corea del Sur" },
  { value: "in", label: "India" },
  { value: "th", label: "Tailandia" },
  { value: "vn", label: "Vietnam" },
  { value: "ph", label: "Filipinas" },

  // Otros
  { value: "au", label: "Australia" },
  { value: "za", label: "Sudáfrica" },
  { value: "il", label: "Israel" },
];

// ── Estado principal ─────────────────────────────────────────────────────────
const peleadores = ref([]);
const cargando = ref(false);
const filtroEstatus = ref("");
const filtroRol = ref("");
const abrirFiltros = ref(false);
const busqueda = ref("");

// ── Ordenamiento ─────────────────────────────────────────────────────────────
const sortCol = ref("nombre");
const sortDir = ref("asc");

function toggleSort(col) {
  if (sortCol.value === col) {
    sortDir.value = sortDir.value === "asc" ? "desc" : "asc";
  } else {
    sortCol.value = col;
    sortDir.value = "asc";
  }
  pagina.value = 1;
}

function sortIconClass(col) {
  if (sortCol.value !== col) return "bi bi-arrow-down-up sort-neutral";
  return sortDir.value === "asc"
    ? "bi bi-arrow-up sort-active"
    : "bi bi-arrow-down sort-active";
}

const peleadoresFiltrados = computed(() => {
  const col = sortCol.value;
  const dir = sortDir.value === "asc" ? 1 : -1;
  const q = busqueda.value.trim().toLowerCase();

  let lista = [...peleadores.value];

  if (q) {
    lista = lista.filter(
      (p) =>
        `${p.nombre} ${p.apellido}`.toLowerCase().includes(q) ||
        (p.email ?? "").toLowerCase().includes(q) ||
        (p.equipo ?? "").toLowerCase().includes(q) ||
        (p.telefono ?? "").toLowerCase().includes(q)
    );
  }

  return lista.sort((a, b) => {
    const va = (a[col] ?? "").toString().toLowerCase();
    const vb = (b[col] ?? "").toString().toLowerCase();
    if (va < vb) return -1 * dir;
    if (va > vb) return 1 * dir;
    return 0;
  });
});

// ── Paginación ───────────────────────────────────────────────────────────────
const pagina = ref(1);
const porPagina = ref(10);

const totalPaginas = computed(() =>
  Math.max(1, Math.ceil(peleadoresFiltrados.value.length / porPagina.value))
);

const paginaActual = computed(() => {
  const inicio = (pagina.value - 1) * porPagina.value;
  return peleadoresFiltrados.value.slice(inicio, inicio + porPagina.value);
});

const paginasVisibles = computed(() => {
  const total = totalPaginas.value;
  const cur = pagina.value;
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages = [1];
  if (cur > 3) pages.push("...");
  for (let i = Math.max(2, cur - 1); i <= Math.min(total - 1, cur + 1); i++)
    pages.push(i);
  if (cur < total - 2) pages.push("...");
  pages.push(total);
  return pages;
});

// ── Carga ────────────────────────────────────────────────────────────────────
async function cargar() {
  pagina.value = 1;
  cargando.value = true;
  try {
    const filtros = {};
    if (filtroEstatus.value) filtros.estatus = filtroEstatus.value;
    if (filtroRol.value) filtros.rol = filtroRol.value;
    peleadores.value = await getPeleadoresDashboard(filtros);
  } catch {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo cargar la lista de peleadores.",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  } finally {
    cargando.value = false;
  }
}

function limpiarFiltros() {
  filtroEstatus.value = "";
  filtroRol.value = "";
  busqueda.value = "";
  cargar();
}

function labelEstatus(est) {
  const mapa = {
    confirmado: "Confirmado",
    pendiente: "Pendiente",
    rechazado: "Rechazado",
  };
  return mapa[est] ?? est ?? "—";
}

// ── Gafetes (pase de identificación) ────────────────────────────────────────
const descargandoGafeteId = ref(null);
const generandoGafetesPdf = ref(false);

function descargarBlobComoArchivo(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

async function extraerErrorBlob(e) {
  const data = e.response?.data;
  if (data instanceof Blob) {
    try {
      return JSON.parse(await data.text())?.detail;
    } catch {
      return null;
    }
  }
  return data?.detail;
}

async function descargarGafetePeleador(p) {
  descargandoGafeteId.value = p.id;
  try {
    const blob = await getGafetePeleadorPdf(p.id);
    descargarBlobComoArchivo(blob, `gafete_${p.nombre}_${p.apellido}.pdf`.replace(/\s+/g, "_"));
  } catch (e) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: (await extraerErrorBlob(e)) || "No se pudo generar el gafete.",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  } finally {
    descargandoGafeteId.value = null;
  }
}

async function descargarGafetesPeleadores() {
  generandoGafetesPdf.value = true;
  try {
    const blob = await getGafetesPeleadoresPdf();
    descargarBlobComoArchivo(blob, "gafetes_peleadores.pdf");
  } catch (e) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: (await extraerErrorBlob(e)) || "No se pudieron generar los gafetes.",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  } finally {
    generandoGafetesPdf.value = false;
  }
}

onMounted(cargar);

// ── Alta masiva ──────────────────────────────────────────────────────────────
const modalAltaMasiva = ref(false);
const filas = ref([]);
const resultados = ref({});
const enviando = ref(false);
const drawerExtraIdx = ref(null);

function filaNueva() {
  return {
    nombre: "",
    apellido: "",
    email: "",
    telefono: "",
    fecha_nacimiento: "",
    genero: "H",
    nacionalidad: "mx",
    peso_kg: "",
    cinta: "",
    equipo: "",
    rol: "Competidor",
    trayectoria: "",
    direccion: "",
    redes_sociales: { instagram: "", facebook: "", youtube: "", twitter: "" },
    notificar: true,
    _foto: null, // File object — no se envía como campo JSON
    _fotoPreview: null, // Data URL solo para previsualizar en el drawer
  };
}

function abrirAltaMasiva() {
  filas.value = [filaNueva()];
  resultados.value = {};
  modalAltaMasiva.value = true;
}
function cerrarAltaMasiva() {
  modalAltaMasiva.value = false;
  if (Object.values(resultados.value).some((r) => r.ok)) cargar();
}
function agregarFila() {
  filas.value.push(filaNueva());
}
function eliminarFila(idx) {
  filas.value.splice(idx, 1);
}
function abrirDatosExtra(idx) {
  drawerExtraIdx.value = idx;
}

const filasValidas = computed(() =>
  filas.value.filter(
    (f) => f.nombre && f.apellido && f.email && f.telefono && f.peso_kg && f.cinta
  )
);

function resultadoFila(idx) {
  if (!resultados.value[idx]) return "";
  return resultados.value[idx].ok ? "fila-ok" : "fila-error";
}

function errorMsgFila(idx) {
  const r = resultados.value[idx];
  return !r || r.ok ? "" : JSON.stringify(r.errores);
}

function limpiarRedes(r) {
  const out = {};
  for (const k of ["instagram", "facebook", "youtube", "twitter"]) {
    if (r?.[k]) out[k] = r[k];
  }
  return out;
}

// ── Foto en drawer de alta masiva ────────────────────────────────────────────
const drawerInputFoto = ref(null);
const drawerFotoDragOver = ref(false);

function onDrawerFotoSeleccionada(e) {
  const file = e.target.files?.[0];
  if (!file || drawerExtraIdx.value === null) return;
  if (!file.type.startsWith("image/")) {
    Swal.fire({
      icon: "error",
      title: "Archivo inválido",
      text: "Solo se permiten imágenes (JPG, PNG, WEBP).",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
    return;
  }
  const reader = new FileReader();
  reader.onload = (ev) => {
    filas.value[drawerExtraIdx.value]._fotoPreview = ev.target.result;
  };
  reader.readAsDataURL(file);
  filas.value[drawerExtraIdx.value]._foto = file;
}

function onDrawerFotoDrop(e) {
  const file = e.dataTransfer.files?.[0];
  if (file) onDrawerFotoSeleccionada({ target: { files: [file] } });
}

function quitarFotoDrawer() {
  if (drawerExtraIdx.value === null) return;
  filas.value[drawerExtraIdx.value]._foto = null;
  filas.value[drawerExtraIdx.value]._fotoPreview = null;
  if (drawerInputFoto.value) drawerInputFoto.value.value = "";
}

async function enviarAltaMasiva() {
  if (!filasValidas.value.length) return;
  enviando.value = true;
  resultados.value = {};

  // Paso 1 — Alta masiva en JSON (sin fotos, el backend solo acepta array JSON)
  const payloadJson = filas.value.map((f) => ({
    nombre: f.nombre,
    apellido: f.apellido,
    email: f.email,
    telefono: f.telefono,
    fecha_nacimiento: f.fecha_nacimiento,
    genero: f.genero,
    nacionalidad: f.nacionalidad,
    direccion: f.direccion,
    peso_kg: parseFloat(f.peso_kg),
    cinta: f.cinta,
    equipo: f.equipo,
    rol: f.rol,
    trayectoria: f.trayectoria,
    redes_sociales: limpiarRedes(f.redes_sociales),
    notificar: f.notificar,
  }));

  try {
    const { resultados: res } = await altaMasivaPeleadores(payloadJson);
    const mapa = {};
    res.forEach((r) => {
      mapa[r.indice] = r;
    });

    // Paso 2 — Subir foto individualmente para los peleadores que la tienen
    const subidaFotos = res
      .filter((r) => r.ok && filas.value[r.indice]?._foto)
      .map(async (r) => {
        const fd = new FormData();
        fd.append("foto", filas.value[r.indice]._foto);
        try {
          await editarPeleador(r.peleador_id, fd);
        } catch (e) {
          // El alta fue OK pero la foto falló — lo anotamos sin marcar la fila como error
          console.warn(`Foto de peleador ${r.peleador_id} no se pudo subir:`, e);
        }
      });
    await Promise.all(subidaFotos);

    resultados.value = mapa;
    const ok = res.filter((r) => r.ok).length;
    const error = res.filter((r) => !r.ok).length;

    if (error === 0) {
      Swal.fire({
        icon: "success",
        title: `✅ ${ok} peleador${ok !== 1 ? "es" : ""} dado${
          ok !== 1 ? "s" : ""
        } de alta`,
        background: "#0f1520",
        color: "#fff",
        confirmButtonColor: "#f3bc2c",
      }).then(cerrarAltaMasiva);
    } else {
      Swal.fire({
        icon: "warning",
        title: `${ok} OK · ${error} con error`,
        text: "Las filas en rojo tienen errores. Corrígelas y vuelve a intentarlo.",
        background: "#0f1520",
        color: "#fff",
        confirmButtonColor: "#f3bc2c",
      });
    }
  } catch {
    Swal.fire({
      icon: "error",
      title: "Error de red",
      text: "No se pudo conectar con el servidor.",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  } finally {
    enviando.value = false;
  }
}

const resumenResultado = computed(() => {
  const vals = Object.values(resultados.value);
  if (!vals.length) return null;
  const ok = vals.filter((r) => r.ok).length;
  const err = vals.filter((r) => !r.ok).length;
  if (err === 0) return { texto: `${ok} dados de alta`, clase: "badge-ok" };
  if (ok === 0) return { texto: `${err} errores`, clase: "badge-error" };
  return { texto: `${ok} ok · ${err} errores`, clase: "badge-warn" };
});

// ── Editar peleador ──────────────────────────────────────────────────────────
const drawerEditar = ref(false);
const peleadorEditar = ref(null);
const guardando = ref(false);
const tabEditar = ref("general");

// Foto
const fotoNueva = ref(null); // File object cuando el usuario selecciona una imagen
const fotoPreview = ref(null); // Data URL para previsualizar antes de guardar
const inputFoto = ref(null); // ref al <input type="file"> oculto
const fotoDragOver = ref(false); // estado de arrastrar sobre la zona

function abrirEditar(p) {
  peleadorEditar.value = {
    ...p,
    redes_sociales: {
      instagram: "",
      facebook: "",
      youtube: "",
      twitter: "",
      ...(p.redes_sociales || {}),
    },
  };
  fotoNueva.value = null;
  fotoPreview.value = null;
  tabEditar.value = "general";
  drawerEditar.value = true;
}

function cerrarEditar() {
  drawerEditar.value = false;
  peleadorEditar.value = null;
  fotoNueva.value = null;
  fotoPreview.value = null;
}

function setRed(red, val) {
  if (peleadorEditar.value) {
    peleadorEditar.value.redes_sociales = {
      ...peleadorEditar.value.redes_sociales,
      [red]: val,
    };
  }
}

// ── Manejo de foto ───────────────────────────────────────────────────────────
function onFotoSeleccionada(e) {
  const file = e.target.files?.[0];
  if (!file) return;
  if (!file.type.startsWith("image/")) {
    Swal.fire({
      icon: "error",
      title: "Archivo inválido",
      text: "Solo se permiten imágenes (JPG, PNG, WEBP).",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
    return;
  }
  fotoNueva.value = file;
  const reader = new FileReader();
  reader.onload = (ev) => {
    fotoPreview.value = ev.target.result;
  };
  reader.readAsDataURL(file);
}

function onFotoDrop(e) {
  const file = e.dataTransfer.files?.[0];
  if (!file) return;
  // Reusar el mismo handler simulando el evento
  onFotoSeleccionada({ target: { files: [file] } });
}

function quitarFotoNueva() {
  fotoNueva.value = null;
  fotoPreview.value = null;
  if (inputFoto.value) inputFoto.value.value = "";
}

async function guardarEdicion() {
  if (!peleadorEditar.value) return;
  guardando.value = true;
  const p = peleadorEditar.value;

  try {
    // Si hay una foto nueva, mandamos multipart/form-data; si no, JSON normal
    if (fotoNueva.value) {
      const fd = new FormData();
      fd.append("nombre", p.nombre);
      fd.append("apellido", p.apellido);
      fd.append("email", p.email);
      fd.append("telefono", p.telefono);
      fd.append("fecha_nacimiento", p.fecha_nacimiento);
      fd.append("genero", p.genero);
      fd.append("nacionalidad", p.nacionalidad);
      fd.append("peso_kg", p.peso_kg);
      fd.append("cinta", p.cinta);
      fd.append("rol", p.rol);
      fd.append("equipo", p.equipo);
      fd.append("trayectoria", p.trayectoria || "");
      fd.append("redes_sociales", JSON.stringify(limpiarRedes(p.redes_sociales)));
      fd.append("foto", fotoNueva.value);
      await editarPeleador(p.id, fd, true); // true = multipart
    } else {
      await editarPeleador(p.id, {
        nombre: p.nombre,
        apellido: p.apellido,
        email: p.email,
        telefono: p.telefono,
        fecha_nacimiento: p.fecha_nacimiento,
        genero: p.genero,
        nacionalidad: p.nacionalidad,
        peso_kg: p.peso_kg,
        cinta: p.cinta,
        rol: p.rol,
        equipo: p.equipo,
        trayectoria: p.trayectoria,
        redes_sociales: limpiarRedes(p.redes_sociales),
      });
    }
    Swal.fire({
      icon: "success",
      title: "Guardado",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      background: "#0f1520",
      color: "#fff",
    });
    cerrarEditar();
    cargar();
  } catch (e) {
    const msg = e.response?.data ? JSON.stringify(e.response.data) : "Error al guardar.";
    Swal.fire({
      icon: "error",
      title: "Error",
      text: msg,
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  } finally {
    guardando.value = false;
  }
}
</script>

<style scoped>
.crud-peleador {
  padding: 32px;
  font-family: "Inter", sans-serif;
  color: #fff;
  min-height: 100%;
}

/* ── Header ── */
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}
.page-title-wrap {
  color: #f3bc2c;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}
.page-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  margin: 4px 0 0;
}
.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

/* ── Búsqueda ── */
.busqueda-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.busqueda-icon {
  position: absolute;
  left: 10px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.35);
  pointer-events: none;
}
.input-busqueda {
  background: #060d1a;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #fff;
  padding: 7px 32px 7px 30px;
  font-size: 13px;
  width: 260px;
  outline: none;
  transition: border-color 0.15s, width 0.2s;
  font-family: "Inter", sans-serif;
}
.input-busqueda::placeholder {
  color: rgba(255, 255, 255, 0.25);
}
.input-busqueda:focus {
  border-color: rgba(243, 188, 44, 0.5);
  width: 300px;
}
.busqueda-clear {
  position: absolute;
  right: 8px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.35);
  cursor: pointer;
  padding: 0;
  font-size: 15px;
  line-height: 1;
  transition: color 0.15s;
}
.busqueda-clear:hover {
  color: #f87171;
}

/* ── Filtros ── */
.filtros-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.filtro-select {
  background: #060d1a;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #fff;
  padding: 7px 12px;
  font-size: 13px;
  cursor: pointer;
}
.filtro-select option {
  background: #060d1a;
}

/* ── Tabla principal ── */
.tabla-wrapper {
  background: #060d1a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  /* ✅ Responsive: scroll horizontal en vez de recortar contenido.
     (La tabla de alta masiva, .tabla-alta-wrapper, ya lo hacía bien). */
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.estado-centro {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 10px;
  color: rgba(255, 255, 255, 0.45);
  font-size: 14px;
}
.tabla {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
  font-size: 13px;
}
.tabla thead tr {
  background: rgba(255, 255, 255, 0.04);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.tabla th {
  padding: 12px 16px;
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.45);
  white-space: nowrap;
}
.th-sortable {
  cursor: pointer;
  user-select: none;
  transition: color 0.15s;
}
.th-sortable:hover {
  color: #f3bc2c;
}
.sort-icon {
  margin-left: 5px;
  font-size: 10px;
}
.sort-neutral {
  opacity: 0.3;
}
.sort-active {
  color: #f3bc2c;
}

.tabla-fila {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: background 0.15s;
}
.tabla-fila:hover {
  background: rgba(255, 255, 255, 0.03);
}
.tabla td {
  padding: 12px 16px;
  vertical-align: middle;
}

.peleador-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.avatar-placeholder {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(243, 188, 44, 0.2);
  color: #f3bc2c;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}
.nombre {
  font-weight: 600;
  margin: 0;
  font-size: 13px;
}
.equipo {
  margin: 0;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
}

/* Cinta coloreada */
.badge-cinta {
  border-radius: 20px;
  padding: 2px 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid transparent;
}
.badge-cinta.blanca {
  background: rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
  border-color: rgba(255, 255, 255, 0.2);
}
.badge-cinta.blanca_amarilla {
  background: rgba(254, 240, 138, 0.12);
  color: #fde047;
  border-color: rgba(250, 204, 21, 0.3);
}
.badge-cinta.amarilla {
  background: rgba(250, 204, 21, 0.15);
  color: #facc15;
  border-color: rgba(250, 204, 21, 0.3);
}
.badge-cinta.naranja {
  background: rgba(251, 146, 60, 0.15);
  color: #fb923c;
  border-color: rgba(251, 146, 60, 0.3);
}
.badge-cinta.verde {
  background: rgba(34, 197, 94, 0.12);
  color: #4ade80;
  border-color: rgba(34, 197, 94, 0.25);
}
.badge-cinta.azul {
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
  border-color: rgba(59, 130, 246, 0.3);
}
.badge-cinta.morada {
  background: rgba(168, 85, 247, 0.15);
  color: #c084fc;
  border-color: rgba(168, 85, 247, 0.3);
}
.badge-cinta.cafe {
  background: rgba(180, 83, 9, 0.18);
  color: #d97706;
  border-color: rgba(217, 119, 6, 0.3);
}
.badge-cinta.negra {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.55);
  border-color: rgba(255, 255, 255, 0.12);
}

.badge-rol {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  padding: 2px 10px;
  font-size: 11px;
  white-space: nowrap;
}
.badge-estatus {
  border-radius: 20px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.badge-estatus.confirmado {
  background: rgba(34, 197, 94, 0.15);
  color: #4ade80;
}
.badge-estatus.pendiente {
  background: rgba(234, 179, 8, 0.15);
  color: #facc15;
}
.badge-estatus.rechazado {
  background: rgba(239, 68, 68, 0.15);
  color: #f87171;
}

/* ── Paginación ── */
.paginacion {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 14px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  flex-wrap: wrap;
}
.pag-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 7px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.pag-btn:hover:not(:disabled) {
  border-color: #f3bc2c;
  color: #f3bc2c;
  background: rgba(243, 188, 44, 0.08);
}
.pag-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.pag-activa {
  background: #f3bc2c !important;
  color: #0f172a !important;
  border-color: #f3bc2c !important;
  font-weight: 700;
}
.pag-ellipsis {
  color: rgba(255, 255, 255, 0.3);
  font-size: 13px;
  padding: 0 4px;
}
.pag-info {
  margin-left: 8px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
}

/* ── Botones ── */
.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #f3bc2c;
  color: #0f172a;
  border: none;
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
}
.btn-primary:hover:not(:disabled) {
  background: #e5ae24;
}
.btn-primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-secondary:hover {
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.05);
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
  border: none;
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: color 0.15s;
}
.btn-ghost:hover {
  color: #fff;
}

.btn-icon {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.15s;
}
.btn-icon:hover {
  color: #f3bc2c;
  background: rgba(243, 188, 44, 0.1);
}

.btn-icon-sm {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  padding: 3px 6px;
  border-radius: 6px;
  font-size: 13px;
  transition: all 0.15s;
}
.btn-icon-sm:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}
.btn-danger-ghost:hover {
  color: #f87171;
  background: rgba(239, 68, 68, 0.1);
}

/* ── Modal ── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.modal-panel {
  background: #0f1520;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  width: 100%;
}
.modal-grande {
  max-width: 1100px;
}
.modal-mediano {
  max-width: 600px;
}
.modal-chico {
  max-width: 560px;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 24px 16px;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}
.modal-titulo {
  font-size: 17px;
  font-weight: 700;
  margin: 0;
  color: #f3bc2c;
}
.modal-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  margin: 4px 0 0;
}

.editar-header-info {
  display: flex;
  align-items: center;
  gap: 12px;
}
.avatar-modal {
  width: 44px !important;
  height: 44px !important;
  font-size: 14px !important;
}

/* ── Tabs ── */
.modal-tabs {
  display: flex;
  gap: 4px;
  padding: 12px 24px 0;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}
.tab-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: rgba(255, 255, 255, 0.45);
  padding: 8px 14px;
  margin-bottom: -1px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}
.tab-btn:hover {
  color: #fff;
}
.tab-activo {
  color: #f3bc2c !important;
  border-bottom-color: #f3bc2c !important;
  font-weight: 600;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  flex-shrink: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  flex-wrap: wrap;
  gap: 10px;
}
.footer-right {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  flex-wrap: wrap;
}

/* ── Tabla alta masiva ── */
.tabla-alta-wrapper {
  overflow: auto;
  flex: 1;
  padding: 0 24px;
}
.tabla-alta {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  min-width: 900px;
}
.tabla-alta thead tr {
  background: rgba(255, 255, 255, 0.04);
  position: sticky;
  top: 0;
  z-index: 1;
}
.tabla-alta th {
  padding: 10px 8px;
  text-align: left;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.45);
  white-space: nowrap;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.tabla-alta td {
  padding: 6px 4px;
  vertical-align: middle;
}
.td-num {
  color: rgba(255, 255, 255, 0.3);
  font-size: 11px;
  width: 28px;
  text-align: center;
}
.td-center {
  text-align: center;
}
.fila-editable {
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}
.fila-ok {
  background: rgba(34, 197, 94, 0.06);
}
.fila-error {
  background: rgba(239, 68, 68, 0.06);
}

.input-tabla {
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: #fff;
  padding: 6px 8px;
  font-size: 12px;
  outline: none;
  transition: border-color 0.15s;
  min-width: 90px;
}
.input-tabla:focus {
  border-color: rgba(243, 188, 44, 0.5);
}
.input-tabla option {
  background: #0f1520;
}
.input-num {
  max-width: 80px;
}
.check-notif {
  accent-color: #f3bc2c;
  width: 15px;
  height: 15px;
  cursor: pointer;
}

/* ── Form grid ── */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.col-span-2 {
  grid-column: span 2;
}
label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.45);
  display: flex;
  align-items: center;
  gap: 5px;
}
.input-form {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #fff;
  padding: 9px 12px;
  font-size: 13px;
  outline: none;
  transition: border-color 0.15s;
  width: 100%;
  font-family: "Inter", sans-serif;
  box-sizing: border-box;
}
.input-form:focus {
  border-color: rgba(243, 188, 44, 0.5);
}
.input-form option {
  background: #0f1520;
}
textarea.input-form {
  resize: vertical;
}

.form-section-label {
  grid-column: span 2;
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #f3bc2c;
  padding: 6px 0 2px;
  border-bottom: 1px solid rgba(243, 188, 44, 0.15);
}

/* ── Resultado badges ── */
.resumen-badge {
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
  padding: 4px 12px;
}
.badge-ok {
  background: rgba(34, 197, 94, 0.15);
  color: #4ade80;
}
.badge-error {
  background: rgba(239, 68, 68, 0.15);
  color: #f87171;
}
.badge-warn {
  background: rgba(234, 179, 8, 0.15);
  color: #facc15;
}

.text-success {
  color: #4ade80;
}
.text-danger {
  color: #f87171;
}

/* ── Foto upload ── */
.foto-upload-zone {
  position: relative;
  width: 34%;
  height: 180px;
  border: 2px dashed rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.2s, background 0.2s;
  background: rgba(255, 255, 255, 0.03);
  display: flex;
  align-items: center;
  justify-content: center;
}
.foto-upload-zone:hover {
  border-color: rgba(243, 188, 44, 0.5);
  background: rgba(243, 188, 44, 0.04);
}
.foto-drag-over {
  border-color: #f3bc2c !important;
  background: rgba(243, 188, 44, 0.08) !important;
}
.foto-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.foto-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.35);
  font-size: 13px;
  text-align: center;
  padding: 16px;
}
.foto-placeholder i {
  font-size: 36px;
  opacity: 0.4;
}
.foto-hint {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.2);
}
.foto-hover-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.2s;
}
.foto-hover-overlay i {
  font-size: 22px;
}
.foto-upload-zone:hover .foto-hover-overlay {
  opacity: 1;
}
.foto-nueva-badge {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  background: rgba(74, 222, 128, 0.08);
  border: 1px solid rgba(74, 222, 128, 0.2);
  border-radius: 6px;
  padding: 5px 10px;
}
.btn-quitar-foto {
  margin-left: auto;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  padding: 0 2px;
  line-height: 1;
  font-size: 15px;
  transition: color 0.15s;
}
.btn-quitar-foto:hover {
  color: #f87171;
}

/* ── Responsive ── */
@media (max-width: 640px) {
  .crud-peleador {
    padding: 16px;
  }
  .page-header {
    flex-direction: column;
    align-items: stretch;
  }
  .header-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .busqueda-wrap {
    width: 100%;
  }
  .input-busqueda {
    width: 100%;
    box-sizing: border-box;
  }
  .header-actions .btn-secondary,
  .header-actions .btn-primary {
    width: 100%;
    justify-content: center;
  }
  .filtros-bar {
    flex-direction: column;
    align-items: stretch;
  }
  .modal-overlay {
    padding: 12px;
  }
}
</style>
